"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const Button_1 = require("decentraland-ui/dist/components/Button/Button");
const UserInformationContainer_1 = require("decentraland-ui/dist/components/UserInformationContainer/UserInformationContainer");
const useAuthContext_1 = __importDefault(require("../../context/Auth/useAuthContext"));
const useProfileContext_1 = __importDefault(require("../../context/Auth/useProfileContext"));
const useAsyncState_1 = __importDefault(require("../../hooks/useAsyncState"));
const useChainId_1 = __importDefault(require("../../hooks/useChainId"));
const manaBalance_1 = require("../../utils/loader/manaBalance");
const Avatar_1 = __importDefault(require("./Avatar"));
require("./UserInformation.css");
function UserInformation(props) {
    const i18n = Object.assign(Object.assign({}, UserInformationContainer_1.UserInformationContainer.defaultProps.i18n), props.i18n);
    const [user, userState] = (0, useAuthContext_1.default)();
    const [profile, profileState] = (0, useProfileContext_1.default)();
    const chainId = (0, useChainId_1.default)();
    const loading = userState.loading || profileState.loading;
    const [manaBalances] = (0, useAsyncState_1.default)(() => __awaiter(this, void 0, void 0, function* () {
        if (props.hideBalance || !user) {
            return {};
        }
        switch (chainId) {
            case chain_id_1.ChainId.ETHEREUM_MAINNET: {
                const [ETHEREUM, MATIC] = yield Promise.all([
                    (0, manaBalance_1.fetchManaBalance)(user, chainId),
                    (0, manaBalance_1.fetchManaBalance)(user, chain_id_1.ChainId.MATIC_MAINNET),
                ]);
                return { ETHEREUM, MATIC };
            }
            case chain_id_1.ChainId.ETHEREUM_SEPOLIA:
            case chain_id_1.ChainId.ETHEREUM_GOERLI:
            case chain_id_1.ChainId.ETHEREUM_RINKEBY:
            case chain_id_1.ChainId.ETHEREUM_ROPSTEN: {
                const [ETHEREUM, MATIC] = yield Promise.all([
                    (0, manaBalance_1.fetchManaBalance)(user, chainId),
                    (0, manaBalance_1.fetchManaBalance)(user, chain_id_1.ChainId.MATIC_MUMBAI),
                ]);
                return { ETHEREUM, MATIC };
            }
            case chain_id_1.ChainId.MATIC_MAINNET:
            case chain_id_1.ChainId.MATIC_MUMBAI: {
                const MATIC = yield (0, manaBalance_1.fetchManaBalance)(user, chainId);
                return { MATIC };
            }
            default:
                return {};
        }
    }), [user, chainId, props.hideBalance]);
    if (loading) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(Avatar_1.default, { loading: true, width: "42", height: "42" })));
    }
    if (!user) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.Button, { primary: !props.isSecondary, inverted: props.isSecondary, size: "small", loading: loading, disabled: loading, onClick: () => userState.select() }, i18n.signIn)));
    }
    return (react_1.default.createElement("div", { className: `dcl-avatar--${user[2]}` },
        react_1.default.createElement(UserInformationContainer_1.UserInformationContainer, Object.assign({}, props, { isSignedIn: true, i18n: i18n, manaBalances: manaBalances || {}, avatar: (profile || undefined), onSignOut: userState.disconnect }))));
}
exports.default = UserInformation;
